import Image from 'next/image';
import { useMemo } from 'react';

import useGetChainInfo from '@/hooks/useGetChainInfo';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function HibachiTradingTriggerDetails({ trigger, triggerType }: Props) {
  const { getChainIconUrl } = useGetChainInfo();
  const chainId = trigger.context?.chainId || trigger.context?.chain_id || 8453;
  const chainName = chainId === 8453 ? 'Base' : `Chain ${chainId}`;

  const chainIconUrl = useMemo(() => {
    return getChainIconUrl(chainId);
  }, [chainId, getChainIconUrl]);

  const chainDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
        {chainIconUrl && <Image src={chainIconUrl} width={16} height={16} alt={chainName} />}
        <span>{chainName}</span>
      </div>
    );
  }, [chainIconUrl, chainName]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Chain" value={chainDisplay} />
    </div>
  );
}
